import { RefObject, useEffect, useState } from "react";

export const useIsVisible = (ref: RefObject<Element>, options?: IntersectionObserverInit) => {
    const [isOnScreen, setIsOnScreen] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) {
            return;
        }

        // `options` (e.g. a rootMargin that trips the observer BEFORE the node
        // actually scrolls into the viewport) is optional and backward-compatible
        // — callers that pass nothing keep the default viewport-intersection
        // behaviour. Used by the Logs tab to prefetch older logs early.
        const observer = new IntersectionObserver(
            ([entry]) => setIsOnScreen(entry.isIntersecting),
            options
        );
        observer.observe(node);

        return () => observer.disconnect();
    });
    // Re-run when the parent re-renders so a ref that materializes after mount is observed.

    return isOnScreen;
};
